/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeEditCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakeEditCtrl', ["dialog", "ngToast", "$scope", "$state", "$stateParams", "StockItems", "Stocktakes", "StocktakeTemplates", "StockUnits", "userinfo", "$window", function(dialog, ngToast, $scope, $state, $stateParams, StockItems, Stocktakes,
    StocktakeTemplates, StockUnits, userinfo, $window) {

  //Fetch the stocktake data
  $scope.stocktake = Stocktakes.getStockApi($stateParams.id);
  $scope.units = StockUnits.getAllActive();

  $scope.stocktake.then(function(stocktake) {// jshint ignore:line
    $scope.stocktake = stocktake;

    if ($scope.stocktake.pending) {
      $scope.stocktake.completedAt = moment().format();
      $scope.stocktake.completedBy = userinfo.userDetails().firstName;
    }

    $scope.headerColWidth = 4;
    if ($scope.stocktake.hasRecipes) {
      $scope.headerColWidth += 1;
    }

    if ($scope.stocktake.hasAreas) {
      $scope.headerColWidth += 1;
    }
  }, function() {
    $state.go('Stock.Stocktakes');
  });

  /**
   * Callback for updating line count
   */
  $scope.updateLineCount = function(line, index) {
    if ($scope.stocktakeEditForm['count' + index].$invalid) {
      ngToast.dismiss();
      ngToast.danger('Invalid stocktake line');
      return;
    }

    line.quantity = parseFloat(line.quantityCounted) + 
      parseFloat(line.quantityRecipe) + 
      parseFloat(line.quantityAreas);

    Stocktakes.updateLineStockApi(line);
  };

  /**
   * Callback for updating line unit
   */
  $scope.updateLineUnit = function(line, newUnit, index) {
    if ($scope.stocktakeEditForm['count' + index].$invalid) {
      ngToast.dismiss();
      ngToast.danger('Invalid stocktake line');
      return;
    }

    //Re-calculate the counted and total quantities so they will be unchanged after the ratio change.
    line.quantityCounted = (line.quantityCounted / line.unitRatio) * newUnit.ratio;
    line.quantity = line.quantityCounted + line.quantityRecipe + line.quantityAreas;
    line.unitRatio = newUnit.ratio;

    Stocktakes.updateLineStockApi(line);

    if (line.itemCountingUnitId != line.unitId) {
      dialog.open({
        templateUrl: 'modules/stock/stocktake/editupdateunitconfirm.tpl.html',
        size: 'sm',
        scope: $scope
      }).then(function(result) {
        if (result.item) {
          StockItems.patch(line.itemId, 'CountingUnitId', line.unitId)
          .then(function() {
            line.itemCountingUnitId = line.unitId;
          });

          if ($scope.stocktake.templateType == 2 && result.template) {
            StocktakeTemplates.updateLineUnit(line.stocktakeTemplateLineId, line.unitId);
          }
        }
      });
    }
  };

  /**
   * Check all lines have units set and open the confirmation dialog.
   */
  $scope.completeStocktake = function() {
    if ($scope.stocktakeEditForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on this stocktake');
      return;
    }

    dialog.open({
      templateUrl: 'modules/stock/stocktake/completeconfirm.tpl.html',
      scope: $scope
    }).then(function(finishType) {
      if (!finishType) {
        return;
      }

      $scope.stocktake.pending = false;

      Stocktakes.updateStockApi($scope.stocktake)
      .then(function() {
        $state.go('Stock.Stocktakes');
      }, function() {
        $scope.stocktake.pending = false;
      });
    });
  };

  /**
   * Callback for 'Save' button
   */
  $scope.saveStocktake = function() {
    $scope.stocktakeEditForm.$setSubmitted();
    if ($scope.stocktakeEditForm.$invalid) {
      ngToast.dismiss();
      ngToast('Please fix the errors on this stocktake');
      return;
    }

    Stocktakes.updateStockApi($scope.stocktake)
    .then(function() {
      $state.go('Stock.Stocktakes');
    });
  };

  /**
   * Callback for 'Delete' button
   */
  $scope.deleteStocktake = function() {
    Stocktakes.remove($scope.stocktake)
    .then(function() {
      $state.go('Stock.Stocktakes');
    });
  };

  $scope.printStocktake = function() {
    $window.print();
  };
}]);
